import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import NoResultsMessage from '../../../../components/NoResultsMessage';
import LoadingSpinner from '../../../../components/Spinner';
import insuredImage from '../../../../noInsuredsImage.png';
import { selectAdminPageFilters, selectAdminPageSearch } from '../../../../redux/modules/adminPage';

function AdminSearchPanel({
  tabName,
  searchFunction,
  allActive,
  allInactive,
  sortFunction,
  allData,
  rowFunction,
  noResultsImage = insuredImage
}) {
  const filter = useSelector(selectAdminPageFilters).find(f => f.name === tabName);
  const search = useSelector(selectAdminPageSearch).find(s => s.name === tabName).value;
  const [activeData, setActiveData] = useState([]);
  const [inactiveData, setInactiveData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredDataLoading, setFilteredDataLoading] = useState(true);

  const showActive = filter.selected === 'active';
  const showInactive = filter.selected === 'inactive';

  const sortByActive = useCallback(() => {
    const sortedData = allData.sort(sortFunction);
    setFilteredData(sortedData);
  }, [allData, sortFunction]);

  useEffect(() => {
    setActiveData(allActive);
    setInactiveData(allInactive);
    setFilteredDataLoading(false);
  }, [allActive, allInactive]);

  useEffect(() => {
    if (showActive) setFilteredData(activeData);
    else if (showInactive) setFilteredData(inactiveData);
    else sortByActive();
    setFilteredDataLoading(false);
  }, [activeData, inactiveData, showActive, showInactive, sortByActive]);

  useEffect(() => {
    let searchData;
    if (showActive) searchData = activeData;
    else if (showInactive) searchData = inactiveData;
    else searchData = allData;

    if (search === '') {
      setFilteredData(searchData);
    } else {
      const results = searchFunction(searchData, search.toLowerCase());
      setFilteredData(results);
    }

    setFilteredDataLoading(false);
  }, [search, filter, showActive, activeData, showInactive, inactiveData, allData, searchFunction]);

  if (!filteredData.length && !filteredData.length) {
    return (
      <NoResultsMessage
        altTag={`No ${tabName}s`}
        image={noResultsImage}
        message={`There are no ${tabName}s to display.`}
      />
    );
  }

  if (filteredDataLoading) {
    return <Box><LoadingSpinner /></Box>;
  }

  return (
    <Box dusk={`${tabName}-search-panel-results-div`}>
      {rowFunction(filteredData)}
    </Box>
  );
}

AdminSearchPanel.propTypes = {
  tabName: PropTypes.string.isRequired,
  searchFunction: PropTypes.func.isRequired,
  allActive: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  allInactive: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sortFunction: PropTypes.func.isRequired,
  allData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rowFunction: PropTypes.func.isRequired,
  noResultsImage: PropTypes.string
};

export default AdminSearchPanel;
